// src/theme/components/cardActionsStyles.js
const cardActionsStyles = (theme) => ({
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2),
          gap: theme.spacing(2),
          justifyContent: "flex-end", // Align buttons to the right by default

          // Make child elements (typically buttons) look more button-like
          "& > *": {
            margin: 0, // Reset margins to use gap instead
            borderRadius: theme.shape.borderRadius * 2,
            padding: theme.spacing(1, 3),
            fontWeight: 500,
            textTransform: "uppercase",
            minWidth: 100,
            textAlign: "center",
            transition: theme.transitions.create(
              ["background-color", "box-shadow", "transform"],
              { duration: theme.transitions.duration.short }
            ),

            // Add visual feedback on hover
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: theme.shadows[2],
            },

            // Add visual feedback on active
            "&:active": {
              transform: "translateY(0)",
              boxShadow: theme.shadows[1],
            },

            // Add default button styling for plain divs/spans used as buttons
            "& > div, & > span": {
              cursor: "pointer",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
            },
          },

          // Style primary actions distinctly from secondary actions
          '& > .MuiButton-containedPrimary, & > [data-primary="true"]': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            fontWeight: 600,
          },

          // Secondary/outlined button styling
          '& > .MuiButton-outlined, & > [data-secondary="true"]': {
            border: `2px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
            backgroundColor: "transparent",

            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          },

          // Text button styling for tertiary actions
          "& > .MuiButton-text": {
            minWidth: "auto",
            padding: theme.spacing(0.5, 1.5),
            backgroundColor: "transparent",
            color: theme.palette.text.secondary,

            "&:hover": {
              backgroundColor: theme.palette.action.hover,
              transform: "none",
              boxShadow: "none",
            },
          },

          // Mobile responsiveness
          [theme.breakpoints.down("sm")]: {
            flexDirection: "column-reverse", // Stack buttons with primary action on top
            padding: theme.spacing(1.5),
            gap: theme.spacing(1),

            "& > *": {
              width: "100%", // Full width buttons on mobile
              padding: theme.spacing(1.25, 2),
            },
          },
        },
      },
  },
});

export default cardActionsStyles;
